<template>
  <div class="page">
	<div class="sidebar">
		<sidebar></sidebar>
	    <div class="sort">
	    	<div class="item">
	    		<h4>首字母</h4>
	    		<div class="itemList">
	    			<a href="javascript:;" :class="{active:index==insLetter}" @click="_sortLetter(item,index)" v-for="(item,index) in sortLetter" :data-sort="item">
	    				<span>{{item}}</span>
	    			</a>
	    		</div>
	    	</div>
	    	<div class="item">
	    		<h4>地区</h4>
	    		<div class="itemList">
	    			<a href="javascript:;" :class="{active:index==insArea}" @click="_sortArea(item,index)" v-for="(item,index) in sortArea" :data-sort="item">
	    				<span>{{item}}</span>
	    			</a>
	    		</div>
	    	</div>
	    </div>
	</div>
  	<div class="pageContainer">
  		<div class="pageTitle">
  			<h3>艺术家</h3>
  		</div>
  		<div class="pageContent">
  			<div class="pageList artist">
  				<ul v-show="newList.length != 0">
  					<li v-for="(item,index) in newList">
  						<a href="javascript:;" :class="{active:index==insArtist}"  @click="SkipLink(index)">
  							<span>{{item.ArtistCN}}</span>
  						</a>
  					</li>
  				</ul>
  				<div class="noData" v-show="newList.length == 0">
  					<p>暂时没有数据，请重新筛选！</p>
  				</div>
  			</div>
  		</div>
  	</div>
  	<div class="pageContainer detailArtist" v-show="currentDetail" :class="{show:currentDetail}">
  		<a href="javascript:;" class="close" @click="close()"></a>
  		<div class="pageTitle">
  			<h3>{{current.ArtistCN}}</h3>
  			<span>{{current.ArtistNationCN}}</span>
  		</div>
  		<div class="pageContent">
  			<swiper-temp :parent="current.Artworks"></swiper-temp>
  		</div>
  	</div>
  </div>
</template>

<script type="text/ecmascript-6">
	import Sidebar from 'base/sidebar/sidebar'
	import SwiperTemp from 'base/swiper/swiper'
	import {ERR_OK} from 'api/config'
	import DataList from 'data/data.json'

	export default {
		data(){
			return{
				list:[],
				newList:[],
				current:[],
				currentDetail:false,
				insArtist:-1,
				insLetter:0,
				insArea:0,
				sortLetter:['所有','A','B','C','D','E','F','G','H','J','K','L','M','N','O','P','R','S','T','U','V','W','X','Y','Z'],
				sortArea:['所有','亚洲','欧洲','北美洲','南美洲','非洲','大洋洲'],
				noData:false
			}
		},
		created(){
			this._getListData()
		},
		methods:{
			_getListData(){
		         let _res = DataList
		         if(_res.status === ERR_OK){
		         	this.list = _res.data;
		         	this.newList = this.list;
		         }
			},
			_sortLetter(item,num){
				let newArr = [];
				if(this.insArea == 0){
					newArr = this.list
				}else{
					newArr = this.searchArea(this.list,this.sortArea[this.insArea])
				}
			    this.insLetter = num
			    if(item == '所有'){
			    	this.newList = newArr
			    }else{
			    	this.newList = this.searchIndex(newArr,item)
			    }
			    this.close();
			    this.insArtist = -1;
			},
			_sortArea(item,num){
				let newArr = [];
				if(this.insLetter == 0){
					newArr = this.list
				}else{
					newArr = this.searchIndex(this.list,this.sortLetter[this.insLetter])
				}
			    this.insArea = num
			    if(item == '所有'){
			    	this.newList = newArr
			    }else{
			    	this.newList = this.searchArea(newArr,item)
			    }
			    this.close();
			    this.insArtist = -1;
			},
			SkipLink(i){
				let _data = this.newList;
				this.current = _data[i];
				this.insArtist=i;
				this.currentDetail = true;
				document.body.style.overflow='hidden';
			},
			close(){
				this.current=[];
				this.currentDetail = false;
				document.body.style.overflow='';
			},
			searchIndex(Arr,keyword){
		        return Arr.filter(item =>{
		          	if(item.Index.includes(keyword)){
			            return item
			       	}
			   })
			},
			searchArea(Arr,keyword){
		        return Arr.filter(item =>{
		          	if(item.ArtistRegionCN.includes(keyword)){
			            return item
			       	}
			   })
			}
		},
	  	components: {
	  		Sidebar,
	  		SwiperTemp
	  	}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	.pageContent{
		padding: 65px 30px;
	}
	.sort{
		width: 385px;
		position: absolute;
		top: 250px;
		left: 180px;
		-webkit-box-sizing: border-box;
		box-sizing: border-box;
		padding:0 30px 0 25px;
		border-left: 1px solid  #707070;
	}
	.sort h4{
		font-size: 16px;
		font-weight: 500;
		line-height: 24px;
		padding-left: 5px;
	}
	.sort .item{
		margin-bottom: 24px;
	}
	.sort .itemList{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		flex-wrap: wrap;
	}
	.sort .itemList a{
		display: block;
		padding: 8px 5px;
		position: relative;
	}
	.sort .itemList a span{
		display: block;
        font-size: 16px;
		text-align: center;
		white-space: nowrap;
	}
	.sort .itemList a.active span{
        background: linear-gradient(to bottom, transparent 0%,transparent 50%,#F6EA37 51%,#F6EA37 100%);
	}
	.sort .item:last-child{
		margin-bottom: 0;
	}

	.artist{
		width: 100%;
		max-width: 900px;
	}
	.artist ul{
		display: -webkit-flex;
		display: -moz-flex;
		display: -ms-flex;
		display: -o-flex;
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	}
	.artist ul li{
		width: 33.3333%;
		margin-bottom: 26px;
	}
	.artist ul li a{
		display: inline-block;
		position: relative;
	}
	.artist ul li a span{
		display: inline-block;
        font-size: 20px;
        font-weight: 200;
		white-space: nowrap;
	}
	.artist ul li a.active span{
        background: linear-gradient(to bottom, transparent 0%,transparent 50%,#F6EA37 51%,#F6EA37 100%);
	}

	.detailArtist{
		position: fixed;
		width: calc(100% - 560px);
		height: 100vh;
		top: 0;
		right: -100%;
		background-color: #EDEDED;
		padding-left: 20px;
		overflow: hidden;
	}
	.detailArtist.show{
		right: 0;
	}
	.detailArtist .pageTitle{
		align-items: start;
		justify-content: center;
		flex-direction: column;
	}
	.detailArtist .pageTitle span{
		display: block;
		margin-top: 15px;
		font-weight: 500;
		font-size: 16px;
	}
	.detailArtist .pageContent{
		width: 100%;
		height: calc(100% - 190px);
		padding: 0;
		position: absolute;
		left: 0;
	}
	.detailArtist .close{
		display: block;
		width: 30px;
		height: 30px;
		position: absolute;
		top: 60px;
		right: 60px;
		background: url(~common/images/CloseBtn.svg) center/contain no-repeat;
	}

	@media screen and (max-width:750px) {
		.pageContent{
			padding: .4rem;
		}
		.sort{
		    width: 100%;
		    position: static;
		    padding: .2rem 0;
		    border-left: 0;
		}
		.sort h4{
			font-size: .28rem;
			line-height: .48rem;
			padding-left: 5px;
		}
		.sort .itemList a{
			padding: .1rem 5px;
		}
		.sort .itemList a span{
	        font-size: .28rem;
		}
		.sort .item{
			margin-bottom: .2rem;
		}
		.artist ul{
			align-items: start;
		}
		.artist ul li{
			width: 50%;
			margin-bottom: .2rem;
		}
		.artist ul li a span{
			font-size: .3rem;
			white-space: normal;
			line-height: 1.2;
		}

		.detailArtist{
			width: 100%;
			height: 100vh;
			right: 0;
			padding-left: 0;
		}
		.detailArtist .pageTitle span{
			margin-top: .2rem;
			font-size: .28rem;
		}
		.detailArtist .close{
			width: .4rem;
			height: .4rem;
			top: .4rem;
			right: .4rem;
		}
		.detailArtist .pageTitle{
			height:2rem;
			-webkit-box-sizing: border-box;
			box-sizing: border-box;
		}
		.detailArtist .pageContent{
			height: calc(100% - 2rem);
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/artist/artist.vue